import { isNil } from "@clipboard-health/util-ts";

import { segmentPluginHelper } from "./segmentPluginHelper";
import { logEvent } from "../../../../appV2/lib/analytics";
import { isCapacitorPlatform } from "../../../../appV2/lib/utils/capacitor/platformUtils";
import { USER_EVENTS } from "../../../../constants";

export function identifyUser(params: {
  worker: { userId: string; phone: string };
  otaBuildId: string;
  version: string;
}): void {
  const { worker, otaBuildId, version } = params;

  // Segment merges with existing traits, only pass those that changed
  const traits = {
    // Required until all users have latest app version; can then remove and rely on backend-main's `identify`
    phone: convertToE164Format(worker.phone),
    otaBuildId,
    version,
  };

  if (isCapacitorPlatform()) {
    void segmentPluginHelper.capacitorIdentify(worker.userId, traits);
  } else {
    if (worker.userId) {
      segmentPluginHelper.webIdentify(worker.userId, traits);
    }
  }
}

export function logApiFailureEvent(error: any, shouldThrowError = false): void {
  const isUrlHasQuery = error?.url && error?.url?.indexOf("?") > -1;
  const properties = {
    reason: "Api Failure",
    message: error?.message || `${error}`,
    requestPath: isUrlHasQuery ? error?.url.substring(0, error?.url.indexOf("?")) : error?.url,
    url: error?.url,
    responseUrl: error?.response?.req?.url,
    status: error?.response?.status,
  };
  logEvent(USER_EVENTS.API_FAILURE, properties);
  if (shouldThrowError) {
    throw error;
  }
}

// oxlint-disable-next-line typescript/unbound-method -- Intentional re-export of helper method
export const { createSegmentInstance } = segmentPluginHelper;

function convertToE164Format(phone?: string): string | undefined {
  if (isNil(phone)) {
    return phone;
  }

  const cleaned = phone.replace(/[^\d]/g, "");
  if (cleaned.length === 10) {
    return `+1${cleaned}`;
  } else if (cleaned.length === 11 && cleaned.startsWith("1")) {
    return `+${cleaned}`;
  }

  return phone;
}
